<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ویرایش آزمون آزاد {{ examDetails.title }}</h1>
          <exam-update
            ref="examUpdate"
            @getExamQuestions="createExamQuestionList"
            @getRemovingQuestions="deleteExamQuestionList"
            v-if="examDetails"
            :oldQuestionsList="examDetails.examQuestions"
          ></exam-update>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getASingleExam();
  },
  data() {
    return {
      isLoading: false,
      examDetails: null,
    };
  },
  methods: {
    async deleteExamQuestionList(questionsList) {
      try {
        let examQuestionIds = [];
        questionsList.forEach((item) =>
          examQuestionIds.push(item.examQuestionId)
        );
        this.isLoading = true;
        let _this = this;
        let deleteExamQuestionList = new DeleteExamQuestionList(_this);
        deleteExamQuestionList.setRequestParamDataObj(examQuestionIds);
        await deleteExamQuestionList.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "آزمون با موفقیت ویرایش شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createExamQuestionList(examQuestion) {
      try {
        this.isLoading = true;
        let _this = this;
        let createExamQuestionList = new CreateExamQuestionList(_this);
        createExamQuestionList.setRequestParamDataObj(examQuestion);
        await createExamQuestionList.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "آزمون با موفقیت ویرایش شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.$refs.examUpdate.resetQuestions();

            _this.getASingleExam();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAPublicExam = new GetAPublicExam(_this);
        getAPublicExam.setRequestParam({ id: _this.$route.params.id });
        await getAPublicExam.fetch((response) => {
          if (response.isSuccess) {
            _this.examDetails = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BModal,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    ExamUpdate,
  },
};
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetAPublicExam } from "@/libs/Api/PublicExam";
import {
  CreateExamQuestionList,
  DeleteExamQuestionList,
} from "@/libs/Api/ExamQuestion";
import ExamUpdate from "@/views/components/Exams/ExamUpdate.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
